import * as actionTypes from '../actions';

const initialState = {
  currentUser: null,
  data: {
    moments: [],
    contents: [],
    numContents: [],
    tags: [],
  },
};

const dataReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        ...state,
        currentUser: action.data,
      };
    case actionTypes.STORE_DATA:
      return {
        ...state,
        data: {
          moments: action.data.moments || state.data.moments,
          contents: action.data.contents || state.data.contents,
          numContents: action.data.numContents || state.data.numContents,
          tags: action.data.tags || state.data.tags,
        },
      };
    default:
      return state;
  }
};

export default dataReducer;
